import { render, staticRenderFns } from "./NotificationScopeSelect.vue?vue&type=template&id=2aad3b3a"
import script from "./NotificationScopeSelect.vue?vue&type=script&lang=ts"
export * from "./NotificationScopeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports